module.exports = __webpack_public_path__ + "img/close-green.e7493dcd.png";